import React, { useContext, useMemo, useState, useEffect, useRef } from "react";

import {
    BrowserRouter as RouterApp,
    Switch,
    Route
} from "react-router-dom";
import AuthContext from "../Context/AuthContext";


import Login from "../components/pages/Login"
import Home from "../components/pages/Home"
import NewPlanPageLCW from "../components/pages/NewPlanPageLCWKonkur"
import NewPlanPageBellona from "../components/pages/NewPlanPageBellona"
import NewPlanPageDominos from "../components/pages/NewPlanPageDominos"
import NewPlanPageDyson from "../components/pages/NewPlanPageDyson"
import NewPlanPageSS from "../components/pages/NewPlanPageSS"
import NewPlanPageToyota from "../components/pages/NewPlanPageToyota"
import CampaignDetail from "../components/pages/CampaignDetail"

export default function Router() {
    const { userData } = useContext(AuthContext);

    return (
        <div>
            <Switch>
                <Route path="/" exact component={Login} />
                <Route path="/login" component={Login} />
                <Route path="/homepage" component={Home} />
                <Route path="/CampaignDetail/:id" component={CampaignDetail} />
                {userData?.user?.user?.username === "LC Waikiki" ? (
                    <Route path="/NewPlan" component={NewPlanPageLCW} />

                ) : null}
                {userData?.user?.user?.username === "Bellona" ? (
                    <Route path="/NewPlan" component={NewPlanPageBellona} />

                ) : null}
                {userData?.user?.user?.username === "Domino's" ? (
                    <Route path="/NewPlan" component={NewPlanPageDominos} />

                ) : null}
                 {userData?.user?.user?.username === "saat&saat" ? (
                    <Route path="/NewPlan" component={NewPlanPageSS} />

                ) : null}
                 {userData?.user?.user?.username === "Toyota" ? (
                    <Route path="/NewPlan" component={NewPlanPageToyota} />

                ) : null}
                {userData?.user?.user?.username === "Dyson" ? (
                    <Route path="/NewPlan" component={NewPlanPageDyson} />

                ) : null}

            </Switch>


        </div>
    )
}
